import {Injectable} from '@angular/core';
import {AmdocsAppsyncClientService} from 'amdocs-core-package';
import {Observable, of} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
@Injectable()
export class EligibilityService {
  constructor( private appSyncClient: AmdocsAppsyncClientService) {
  }
  getEligibility(apsSupportOneRequest,sessionContextInput?): Observable<any> {
    const eligibilityQuery = `query GetEligibilityRuleFromAPS($apsSupportOneRequest: ApsSupportOneRequestInput!,$sessionContextInput:SessionContextInput) {
      getEligibilityRuleFromAPS(apsSupportOneRequest: $apsSupportOneRequest,sessionContextInput: $sessionContextInput) {
        params {
           Dac_SessionID
            ErrorDesc
            IsEligible
            SO_SessionID
            UPN
            User_ID
        }
        queryDefinition {
          userQuery
            filter {
              field
              type
              values
            }
          }
        results {
          size
          group {
            field
            size
          }
          sort {
            order
            value
          }
          start
        }
      }
    }
  `;
    const paramsvalues = {
      apsSupportOneRequest:apsSupportOneRequest,
      sessionContextInput: sessionContextInput ? sessionContextInput : null
    };
    return this.appSyncClient.call(eligibilityQuery, 'GetEligibilityRuleFromAPS', paramsvalues).pipe(
        mergeMap( (res: any): Observable<any> => {
          return of(res);
        }),
        catchError( err => {
          console.log(err);
          return of({error: err});
        })
    );
  }
}
